/*****************************************************************************************************/
// Define global variables and objects available for all VUE instances
window.Vue.mixin({
    data() {
        return {
            INSTANCE: {
                MobileDetect: new MobileDetect(window.navigator.userAgent),
            },
            SUPPORTS_TOUCH: 'ontouchstart' in window || navigator.msMaxTouchPoints,
        };
    },
    mounted() {
        let metabetEl = document.getElementsByClassName('metabet-odds-board')

        // Ensure metabet widget loads once after Vue instance has mounted
        if (typeof mb_DOMContentLoaded === 'function' && metabetEl.length !== 0 && ! window.hasLoadedMetabet) {
            window.hasLoadedMetabet = true
            localStorage.removeItem('metabet-location')
            mb_DOMContentLoaded()
        }
    }
});